import React, { Component } from 'react';
import firebase from '../../config/Firebase'

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            passwordConfirm: '',
            displayName: '',
            firebaseError: null
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    writeUserData = (userId, name, email, password) => {
        firebase.database().ref('users/' + userId).set({
            email: email,
            password: password,
            name: name,
            role: "client"
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { password, passwordConfirm } = this.state;
        if (password === passwordConfirm) {

        } else {
            alert("Password not match !")
        }
        firebase.auth().createUserWithEmailAndPassword(this.state.email, password)
            .then(user => {
                this.writeUserData(user.user.uid, this.state.displayName, this.state.email, this.state.password)
            })
            .catch(err => {
                this.setState({
                    firebaseError: err.message
                })
            })
    }

    render() {
        var { displayName, email, password, passwordConfirm, firebaseError } = this.state;
        return (
            <>
                {firebaseError}
                <div>
                    <input
                        type="text"
                        name="displayName"
                        placeholder="Full Name"
                        value={displayName}
                        onChange={this.handleChange}
                    />
                    <br />
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={this.handleChange}
                    />
                    <br />
                    <input
                        type="password"
                        name="password"
                        value={password}
                        placeholder="Password"
                        onChange={this.handleChange}
                    />
                    <input
                        type="password"
                        name="passwordConfirm"
                        value={passwordConfirm}
                        placeholder="Password Confirm"
                        onChange={this.handleChange}
                    />
                    <input
                        type="submit"
                        value="Register"
                        onClick={this.handleSubmit}
                    />
                </div>
            </>
        );
    }
}

export default Register;
